import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { RadioGroup, FormControlLabel, FormControl, InputLabel, TextField, Select, MenuItem, Checkbox } from '@mui/material';

class VoterDetails extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { t, i18n } = this.props;
        const { vote_grab_name, vote_grab_country, vote_grab_zipcode, vote_grab_consent, consent_text } = this.props.settings.contest;
        const { countries } = this.props;
        const { voter_name, voter_country, voter_zipcode, voter_terms } = this.props.voter_state;

        return (
            <React.Fragment>
                {
                    vote_grab_name == 'on' &&
                    <TextField className="wpvc_text_field"
                        type="text" name="voter_name"
                        label={t("enter_voter_name")}
                        onChange={(event) => this.props.handleVoterDetails(event)}
                        fullWidth
                    />
                }
                {vote_grab_name == 'on' && this.props.validator.message(t('voter_name_required'), voter_name, 'required')}

                {
                    vote_grab_country == 'on' &&
                    <FormControl className='wpvc_select_country'>
                        <InputLabel>{t("select_voter_country")} </InputLabel>
                        <Select variant='standard'
                            name="voter_country"
                            className="wpvc_text_field"
                            autoWidth
                            onChange={this.props.handleVoterDetails} fullWidth
                            defaultValue=""
                        >
                            {Object.keys(countries).map((key) => (
                                <MenuItem key={key} value={key}>{countries[key]}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }

                {vote_grab_country == 'on' && this.props.validator.message(t('voter_country_required'), voter_country, 'required')}

                {
                    vote_grab_zipcode == 'on' &&
                    <TextField className="wpvc_text_field"
                        type="text" name="voter_zipcode"
                        label={t("enter_voter_zipcode")}
                        onChange={(event) => this.props.handleVoterDetails(event)} fullWidth
                    />
                }
                {vote_grab_zipcode == 'on' && this.props.validator.message(t('voter_zipcode_required'), voter_zipcode, 'required')}

                {
                    vote_grab_consent == 'on' &&
                    <FormControl component="fieldset">
                        <RadioGroup row>
                            <FormControlLabel control={<Checkbox color="primary" name="voter_terms" onChange={(event) => this.props.handleVoterDetails(event)} style={{ marginRight: 10 }} />} label={<p dangerouslySetInnerHTML={{ __html: consent_text }}></p>} ></FormControlLabel>
                        </RadioGroup>
                    </FormControl>
                }
                {vote_grab_consent == 'on' && this.props.validator.message(t('consent_validation_text'), voter_terms, 'consent')}
            </React.Fragment>
        )
    }
}
export default (withTranslation("translations")(VoterDetails));